export default "__VITE_ASSET__CApf3OLf__"